module.exports = __webpack_public_path__ + "assets/assets/images/illustrations/legal.3c18e01c.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/illustrations/legal.png
// module id = 537
// module chunks = 0